import React from "react";
import { motion } from "framer-motion";
import { Gauge, TrendingUp, TrendingDown, DollarSign } from "lucide-react";

const CostIndicators = ({ data }) => {
    return (
        <div className="mt-8">
            <div className="d-flex align-items-center gap-2 mb-6">
                <div className="p-2 bg-purple-50 rounded-lg text-purple-600">
                    <Gauge size={20} />
                </div>
                <h2 className="text-xl font-bold text-gray-800 m-0">Cost & Inflation Indicators</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
                {data.map((item, i) => {
                    const isNegative = item.yoy < 0;
                    return (
                        <motion.div
                            key={i}
                            whileHover={{ scale: 1.02 }}
                            className="bg-white p-5 rounded-3xl shadow-sm border border-gray-100 transition-all"
                        >
                            <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider mb-2">{item.index}</p>
                            <div className="d-flex align-items-baseline gap-2">
                                <span className="text-xl font-bold text-gray-900">
                                    {typeof item.value === 'number' ? item.value.toLocaleString() : item.value}
                                </span>
                                <div className={`d-flex align-items-center gap-0.5 text-xs font-bold ${isNegative ? 'text-green-600' : 'text-red-500'}`}>
                                    {isNegative ? <TrendingDown size={12} /> : <TrendingUp size={12} />}
                                    {(Math.abs(item.yoy) * 100).toFixed(1)}%
                                </div>
                            </div>
                        </motion.div>
                    );
                })}
            </div>
        </div>
    );
};

export default CostIndicators;